import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { createUseStyles } from 'react-jss';
import { theme, Theme } from '@app/theme';

import logo from '@app/illu/Branding/Logo.svg';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  qrCode: {
    borderRadius: theme.borderRadius.std * 2,
  },
}));

interface Props {
  link: string;
  className?: string;
}

export const DisplayQrCode = ({ link, className }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <QRCodeSVG
        value={link}
        size={240}
        level="H"
        className={classnames(classes.qrCode, className)}
        fgColor={theme.colors.inkPrimary}
        bgColor={theme.colors.white}
        imageSettings={{
          src: logo,
          height: 48,
          width: 48,
          excavate: true,
        }}
      />
    </div>
  );
};
